import { render } from "./AchievementsSection.vue?vue&type=template&id=6bb56a56&scoped=true"
import script from "./AchievementsSection.vue?vue&type=script&lang=js"
export * from "./AchievementsSection.vue?vue&type=script&lang=js"

import "./AchievementsSection.vue?vue&type=style&index=0&id=6bb56a56&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb56a56"]])

export default __exports__